// src/autodesk_usage/hooks/useCompanyAccountInfo.ts
// All comments in English only
import { useQuery } from "@tanstack/react-query";
import {
  getCompanyAccountInfo,
  type CompanyAccountInfo,
} from "../api/corporate";

export interface UseCompanyAccountInfoResult {
  data?: CompanyAccountInfo | null;
  isLoading: boolean;
  error: unknown;
}

export function useCompanyAccountInfo(
  companyName?: string | null
): UseCompanyAccountInfoResult {
  const query = useQuery<CompanyAccountInfo | null>({
    queryKey: ["company-account-info", companyName],
    queryFn: async () => {
      if (!companyName) return null;
      const res = await getCompanyAccountInfo(companyName);
      return res.data ?? null;
    },
    enabled: !!companyName,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
